import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { FacilityService } from './../facility.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import { AppService } from '../../app.service';

import {
    MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck
} from './../../shared/message.event';

import { UISETTING } from './../../shared/ui-setting';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-facility-dashboard',
    templateUrl: './facility-dashboard.component.html',
    styleUrls: ['./facility-dashboard.component.css'],
    providers: [FacilityService, MessageEvent, SignInEvent, LoaderEvent, FacilityListEvent, OpenFrameEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck]
})

export class FacilityDashboardComponent implements OnInit {
    public appCall: any;
    private _router;
    private facilityData;
    private bgColor;
    private shouldSlide: boolean = false;
    private facilityList = [];
    private noFacilityText = true;
    private popUpMessage: any;
    private popUp: any;
    private vendor;
    private clubName;
    private messageNoActivityAdded;
    private uiSetting: UISETTING;
    private height: any;
    private utilityFunctions = new UtilityFunctions;
    private scrollOptions: ISlimScrollOptions;

    constructor(private router: Router, private facilityService: FacilityService, private appService: AppService,
        private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private facilityListEvent: FacilityListEvent, private openFrameEvent: OpenFrameEvent,
        private sidemenuSubCategory: SidemenuSubCategory, private hiddenFooter: HiddenFooter, private setAllMemberCheck: SetAllMemberCheck) {
        this.uiSetting = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 40
        }
        this.scrollOptions = {
           barBackground: "#343a40", barOpacity: "0.6", position: "right",
           barWidth: "6", barBorderRadius: "5",barMargin:"1px 1px",gridBackground:"#adb5bd",gridOpacity:"1",gridWidth:"4",gridBorderRadius:"10",gridMargin:"1px 2px"
        };
        this.height = 0;
        this._router = router;
        this.bgColor = CONSTANT_VALUES.COLOR;
        // calculating height of current frame
        this.height = (this.uiSetting.windowHeight - (this.uiSetting.topNav + this.uiSetting.midNav + this.uiSetting.container + this.uiSetting.footer)) + 'px';
        this.messageNoActivityAdded = CONSTANT_MESSAGES.MESSAGE_NO_ACTIVITY_ADDED;
    }

    ngOnInit() {
        this.emitOpenFrameEvent();
        window.scrollTo(0, 0);
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                this.clubName = subVendor.clubName;
            }
        } else {
            this.clubName = this.vendor.clubName;
        }
        this.getFacilityByClub();
        let obj = {
            category: 'All Facilities',
            menu: 'Activities'
        };
        this.sidemenuSubCategory.fire(obj);
        this.removePreviousFacilityFromLocalStorage();
        this.loaderEvent.fire(false);
        this._router.navigate(['/facility']);
        this.registerTypeBroadcast();
        this.emitTypeBroadcast();
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too like menu by broadcaster  
     */

    registerTypeBroadcast() {
        this.messageEvent.on()
            .subscribe(message => {
                this.shouldSlide = message;
            });
    }

    /**
     * get facilities belongs with sign in user (Vendor) from DB and display
     * 
     * @param vendor object
     * 
     * @response got list of facility
     */

    getFacilityByClub() {
        let vendorObj = {
            vendorId: ''
        };
        if (this.vendor.role == CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
            vendorObj.vendorId = this.vendor._id;
        } else if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
            if (this.vendor.subVendors.length > 0) {
                let subVendor = this.vendor.subVendors[0];
                vendorObj.vendorId = subVendor._id;
            }
        }
        let that = this;
        this.appService.getClubFacility(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.facilityData = result.facilityData;
                let count = 0;
                if (this.facilityData.length === 0) {
                    this.noFacilityText = false;
                } else {
                    this.noFacilityText = true;
                }
                this.facilityData = this.facilityData.map(function (rec) {
                    rec.data = rec.data.map(function (dataIcon) {
                        dataIcon.iconClass = _.find(CONSTANT_VALUES.ICON_LIST_IMAGE, { name: dataIcon.icon }).iconClass;
                        dataIcon.color = that.bgColor[count];
                        count++;
                        if (count >= that.bgColor.length) {
                            count = 0;
                        }
                        return dataIcon;
                    });
                    return rec;
                });
                this.facilityListEvent.fire(this.facilityData);
                localStorage.setItem('vendor_facilityData', btoa(JSON.stringify(this.facilityData)));
            } else {
                this.popUp = true;
                this.popUpMessage = result.message;
            }
            this.loaderEvent.fire(true);
        }).catch((err) => {
            this.popUp = true;
            this.popUpMessage = err;
        });
        // this.facilityData = JSON.parse(atob(localStorage.getItem('vendor_facilityData')));
    }

    /** 
     * Redirecting to add facility page
     */
    openAddFacilityForm() {
        this._router.navigate(['/addfacility']);
    }
    /**
     * View facilities on dashboard
     * 
     * @param {any} data 
     * @param {any} facilityArray 
     * 
     * @memberOf FacilityDashboardComponent
     */
    viewFacility(data, facilityArray) {
        let count = 0;
        for (let facility of facilityArray.data) {
            this.facilityList[count] = facility.name;
            count++;
        }
        localStorage.setItem('facilityList', btoa(JSON.stringify(this.facilityList)));
        this.appService.storeFacility(data);
        this._router.navigate(['/addfacility']);
    }

    /**
     * function show menu at facility page by broadcaster
     */

    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'block'
        };
        this.signInEvent.fire('block');
        this.hiddenFooter.fire(isShow);
    }
    emitTypeLoaderBroadcast() {
        this.loaderEvent.fire(false);
    }
    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    /**
     * Redirecting to member page
     */

    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }

    /**
     * Remove previous facility from local storage.
     */
    removePreviousFacilityFromLocalStorage() {
        if (localStorage.getItem('facility')) {
            localStorage.removeItem('facility');
        }
        if (localStorage.getItem('currentCategory')) {
            localStorage.removeItem('currentCategory');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/facility/facility-dashboard/facility-dashboard.component.ts